import React from "react";
import TopNav from "../../../Components/Admin/shared/TopNav";
import { useState } from "react";
import TableRow from "../../../Components/Admin/AcceptingUsers/TableRow";
import DeleteModal from "../../../Components/Admin/shared/DeleteModel";
import Header from "../../../Components/Admin/shared/HeaderTable";

const rowsText = [
  "Parent Name",
  "Phone",
  "Child Name",
  "birthday",
  "Child Condition",
  "Child Report",
  "Actions",
  "createdAt",
  "updatedAt",
];

const searchTypes = [
  "parentName",
  "childCondition",
  "childName",
  "email",
  "birthday",
  "phone",
];

const itemsPerPage = 5;

const AcceptingUsers = () => {
  const [isDelete, setIsDelete] = useState(false);

  const [search, setSearch] = useState("");
  const [searchType, setTypeSearch] = useState("");
  const [searchAction, setSearchAction] = useState(false);

  const [idUserForDelete, setIdUserForDelete] = useState(0);

  const [status, setStatus] = useState({
    show: false,
    icon: "success",
    title: "",
    description: "",
    showConfirmButton: true,
    timer: 10000,
  });

  function handleModal(setState, value) {
    setState(value);
  }

  return (
    <>
      <div className=' md:p-10  p-4 bg-[#f5f5f5]'>
        <Header
          setSearch={setSearch}
          setTypeSearch={setTypeSearch}
          handleModal={handleModal}
          searchTypes={searchTypes}
          title={"Search users"}
          setSearchAction={setSearchAction}
        />

        <TableRow
          title={"Users List"}
          className='table-auto'
          setIsDelete={setIsDelete}
          handleModal={handleModal}
          rows={rowsText}
          search={search}
          searchType={searchType}
          itemsPerPage={itemsPerPage}
          setIdUserForDelete={setIdUserForDelete}
          status={status}
          setStatus={setStatus}
          searchAction={searchAction}
          setSearchAction={setSearchAction}
        />

        <DeleteModal
          handleModal={handleModal}
          setIsDelete={setIsDelete}
          isDelete={isDelete}
          idForDelete={idUserForDelete}
          setStatus={setStatus}
          url={"admin/delete_user"}
        />
      </div>
    </>
  );
};

export default AcceptingUsers;
